import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'
import { login_status } from './types'
export interface DetailRequestParams {
  /** 设备id */
  device_id: string
}

export interface VirusRisk {
  /** 未处理病毒风险数量 */
  untreated_virus_count: number
  /** 病毒类型列表 */
  virus_types: number[]
}

export interface RansomwareRisk {
  /** 勒索风险事件数量 */
  ransomware_count: number
  /** 风险等级 */
  level: number
}

export interface LeakRisk {
  /** 未修复漏洞总数 */
  leak_count: number
  /** 漏洞等级 */
  warn_level: number
  /** 漏洞等级描述 */
  warn_level_str: string
}

export interface BaselineRisk {
  /** 扫描项数量 */
  scan_item_count: number
  /** 违规项数量 */
  violation_item_count: number
}

export interface PortRisk {
  /** 端口开放总数 */
  open_port_count: number
  /** 风险端口数量 */
  risk_port_count: number
  /** 未知端口数量 */
  unknown_port_count: number
}

export interface WeakPasswordRisk {
  /** 检测的账户数量 */
  account_count: number
  /** 弱口令账户数量 */
  weak_password_account_count: number
}

export interface RiskDetail {
  /** 病毒风险 */
  virus_risk: VirusRisk
  /** 勒索风险 */
  ransomware_risk: RansomwareRisk[]
  /** 漏洞风险 */
  leak_risk: LeakRisk[]
  /** 基线风险 */
  baseline_risk: BaselineRisk
  /** 端口风险 */
  port_risk: PortRisk
  /** 弱口令风险 */
  weak_password_risk: WeakPasswordRisk
}

export interface DetailResponseData {
  /** 风险详情 */
  risk_detail: RiskDetail
}

export interface ProcessInfoRequestParams {
  /** 终端设备id集合 */
  device_list?: string[]
  /** 分组id */
  group_id?: number
}

export interface ProcessInfoResponseData {
  /** 任务id */
  task_id?: string
}

export interface WeakInfoRequestParams {
  /** 终端设备id集合 */
  device_list?: string[]
  /** 分组id */
  group_id?: number
  execute_type: 0|1
}

export interface WeakInfoResponseData {
  /** 任务id */
  task_id?: string
}

export interface TerminalOrderRequestParams {
  /** 隔离终端启用 1=启用，2=关闭 */
  isolation_enabled?: number
  /** 终端设备id集合 */
  device_list?: string[]
  /** 0-指定终端，1-整个分组 */
  execute_type?: number
  /** 分组id */
  group_id?: number
}

export interface TerminalOrderResponseData {
  /** 任务id */
  task_id?: string
}
export interface TerminalRiskRequestParams {
  /** 分组id */
  group_id: number
  /** 设备id */
  device_id: string
  /** 顺序，true-正序，false-逆序 */
  asc?: boolean
  /** 关键词搜索 */
  key_word?: string
  /** 每页数量 */
  limit?: number
  /** 终端状态 0-全部, 1-在线，2-离线 */
  login_status?: number
  system_type?: number
  // 权益key集合
  permission_names: string[]
  /** 当前页 */
  page?: number
  /** 风险类型, 1=病毒风险,2=漏洞风险,3=端口风险,4=基线风险,5=勒索风险, 6=弱口令风险 */
  risk_type?: number
  /** 排序字段 */
  sort?: string
  isolation_status: login_status
}

export interface AuthStatus {
  /** 权益key名 */
  permission_name: string
  /** 授权状态：0-正常，1-待授权 2-未订阅 */
  auth_status: number
}

export interface RiskTerminalList {
  /** 终端设备id */
  device_id: string
  /** 分组id */
  group_id: number
  /** 计算机名 */
  computer_name: string
  /** 内网ip,以"，"分隔 */
  system_ip: string
  /** 终端版本 */
  version: string
  /** 防护状态 1-开启，2-关闭 */
  defence_status: number
  /** 登记用户名 */
  user_mark: string
  /** Mac地址 */
  mac: string
  /** 操作系统 */
  system_name: string
  /** 本次开机时间,时间戳(秒) */
  current_startup_time: number
  /** 今天在线时长,单位秒 */
  today_online_time: number
  /** 上次开机时间,时间戳(秒) */
  last_startup_time: number
  /** 上次离线时间,时间戳(秒) */
  last_offline_time: number
  /** 终端登录状态,1-在线，2-离线 */
  login_status: number
  /** 外网ip */
  client_ip: string
  /** 分组名 */
  group_name: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
  /** 操作系统 */
  os: string
  /** 授权状态集合 */
  auth_status?: AuthStatus[]
  /** 端口风险数 */
  danger_port_count?: number
  /** 是否开启调试模式 1=是，2=否 ，0=未知 */
  debug_enabled?: number
  /** 是否有桌面系统 */
  is_desktop?: number
  /** 隔离状态, 1=已隔离，2=未隔离，0=未知 */
  isolation_status?: number
  /** 漏洞风险数 */
  leak_count?: number
  /** 勒索风险数 */
  ransomware_count?: number
  /** 授权服务数量 */
  service_count?: number
  /** 基线风险数 */
  substandard_count?: number
  /** 病毒风险数 */
  unhandled_risk_count?: number
  /** 弱口令风险数 */
  weak_password_account_count?: number
}

export interface TerminalRiskResponseData {
  /** 终端信息 */
  risk_terminal_list: RiskTerminalList[]
  /** 总数 */
  total: number
}
export interface TerminalRiskStatisticsResponseData {
  /** 风险终端数 */
  risk_terminal_count: number
  /** 病毒影响终端数 */
  virus_affect_count: number
  /** 漏洞影响终端数 */
  leak_affect_count: number
  /** 端口影响终端数 */
  port_affect_count: number
  /** 基线扫描不合规数 */
  baseline_substandard_count: number
  /** 勒索威胁影响终端数 */
  ransomware_affect_count: number
  /** 弱口令影响终端数 */
  weak_password_affect_count: number
  /** 隔离终端数 */
  isolation_count: number
}
export interface LoginSessionHistoryRequestParams {
  /** 团队id */
  team_id: string
  /** 设备id */
  device_id: string
  /** 用户名 */
  name: string
  /** 主机名 */
  domain: string
  /** 开始时间 */
  start_time: string
  /** 结束时间 */
  end_time: string
}

export interface Data {
  /** 登录时间 */
  LoginTime: string
  /** 登出时间 */
  LogoutTime: string
}

export interface LoginSessionHistoryResponseData {
  /** 登录历史信息 */
  data: Data[]
}

export interface ProcessListRequestParams {
  /** 设备id */
  device_id: string
  /** 顺序，true-正序，false-逆序 */
  asc?: boolean
  /** 每页数量 */
  limit?: number
  /** 当前页 */
  page?: number
  /** 排序字段 */
  sort?: string
}

export interface ProcessListData {
  /** id */
  id: string
  /** 团队ID */
  team_id: string
  /** 设备ID */
  device_id: string
  /** 进程PID */
  pid: number
  /** 进程名称 */
  process_name: string
  /** 威胁状态（如安全/风险/未知） */
  threat_status: string
  /** 进程路径 */
  path: string
  /** 进程描述 */
  description: string
  /** CPU 使用率（百分比） */
  cpu_usage: number
  /** 内存使用量 */
  memory_usage: string
  /** 运行该进程的用户名 */
  username: string
  /** 文件 MD5 */
  file_md5: string
  /** 数字签名 */
  digital_signature: string
  /** 进程创建时间（Unix 时间戳） */
  process_create_time: string
  /** 记录创建时间（Unix 时间戳） */
  create_time: string
}

export interface ProcessListResponseData {
  /** 终端信息 */
  data: ProcessListData[]
  /** 总数 */
  total: number
}
export interface CloseProcessRequestParams {
  /** 终端设备id */
  device_id: string
  /** 进程id */
  pid: number
  /** 进程创建时间 */
  process_create_time: string
}

export interface CloseProcessResponseData {
  /** 任务id */
  task_id?: string
}
export interface LastCommandTaskRequestParams {
  /** 命令id, 获取进程=32，获取弱口令账户=33 */
  command_id?: number
  /** 设备列表 */
  device_list?: string[]
}

export interface LastCommandTaskData {
  /** 任务id */
  task_id: string
  /** 命令任务id */
  order_id: string
  /** 状态 */
  status: number
  /** 描述 */
  desc: string
  /** 创建时间戳 */
  create_time: string | number
  /** 更新时间戳 */
  update_time: string
}

export interface LastCommandTaskResponseData {
  data?: LastCommandTaskData[]
}

export interface IsolationStatusRequestParams {
  /** 权益key集合 */
  device_list: string[]
}

export interface IsolationStatusResponseData {
  /** 隔离状态列表 */
  isolation_status_list: number[]
}
@Injectable()
export class ResponseHandlingService {
  constructor (private http: Http) {
  }
  // 终端风险详情
   getTerminalRiskDetail (data: DetailRequestParams) {
    return this.http.post<DetailResponseData>('/terminal/risk_detail', data)
  }
  // 获取进程信息
  getTerminalOrderGetProcessInfo (data: ProcessInfoRequestParams) {
    return this.http.post<ProcessInfoResponseData>('/terminal-order/get_process_info', data)
  }
  // 获取弱口令账户信息
  getTerminalOrderGetWeakPasswordInfo (data: WeakInfoRequestParams) {
    return this.http.post<WeakInfoResponseData>('/terminal-order/get_weak_password_account', data)
  }
  //登录历史
  getTerminalAccountLoginSessionHistory (data: LoginSessionHistoryRequestParams) {
    return this.http.post<LoginSessionHistoryResponseData>('/terminal/account/login_session_history', data)
  }
  // 隔离终端
  getTerminalOrderIsolation (data: TerminalOrderRequestParams) {
    return this.http.post<TerminalOrderResponseData>('/terminal-order/isolation', data)
  }
  // 获取风险终端列表
  @ParamsClean()
  getTerminalRiskList (data: TerminalRiskRequestParams) {
    data.risk_type ||= 0
    data.login_status ||= 0
    data.isolation_status ||= 0
    data.system_type ||= 0
    return this.http.post<TerminalRiskResponseData>('/terminal/risk_list', data)
  }
  // 风险终端统计
  getTerminalRiskStatistics () {
    return this.http.post<TerminalRiskStatisticsResponseData>('/terminal/risk_statistics', {})
  }
  // 终端进程列表
  @ParamsClean()
  getTerminalProcessList (data: ProcessListRequestParams) {
    return this.http.post<ProcessListResponseData>('/terminal/process_list', data)
  }
  // 结束进程
  getTerminalOrderCloseProcess (data: CloseProcessRequestParams) {
    return this.http.post<CloseProcessResponseData>('/terminal-order/close_process', data)
  }
  getCommandserverGetLastCommandTask (data: LastCommandTaskRequestParams) {
    return this.http.post<LastCommandTaskResponseData>('/commandserver/get_last_command_task', data)
  }
  // 更新隔离状态
  getTerminalGetIsolationStatus (data: IsolationStatusRequestParams) {
    return this.http.post<IsolationStatusResponseData>('/terminal/get_isolation_status', data)
  }
}
